import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from '../../../auth/auth.module';
import { SearchModule } from '../../../shared/components/search/search.module';
import { TitleRegistrationService } from '../../../titleregistration/services/titleregistration.service';
import { VehicleSearchModule } from '../../../vehicle/search/vehicle-search/vehicle-search.module';
import { VehicleSearchBarComponent } from './vehicle-search-bar.component';

@NgModule({
    declarations: [
        VehicleSearchBarComponent
    ],
    providers: [
        TitleRegistrationService
    ],
    imports: [
        AuthModule,
        CommonModule,
        SearchModule,
        VehicleSearchModule
    ],
    exports: [
        VehicleSearchBarComponent
    ]
})
export class VehicleSearchBarModule {
}
